import React from 'react'
import './css/Accessorie.css'


const Accessorie = () => {
  return (
    <div className='accessories' >
      <div className="accessories-template">
        <p>Sound expandable like High quality Straps <span> (ANKLE, CALF, THIGH, WAIST, CHEST)</span></p>
      </div>
        <div className="accessories-template">
        <p> windcover <span>(REDUCE LAVALIERE WIND NOISE)</span></p>
      </div>
        <div className="accessories-template">
        <p> Undercover</p>
      </div>
        <div className="accessories-template">
        <p>Stickies</p>
      </div>
        <div className="accessories-template">
        <p> Fur<span> (REDUCE LAVALIERE WIND NOISE)</span></p>
      </div>
        <div className="accessories-template">
        <p>Toupee Tapes</p>
      </div>
        <div className="accessories-template">
        <p>Shoe pads<span>(FIXES TO ARTISTS SHOE HEELS TO SUPPRESS THE NOISE WHILE THEY WALK)</span></p>
      </div>
        <div className="accessories-template">
        <p> Lav Concealer<span> (FOR VARIOUS LAVALIERE)</span></p>
      </div>
        <div className="accessories-template">
        <p>Magic arm</p>
      </div>
        <div className="accessories-template">
        <p>We import products from USA and UK</p>
      </div>

    </div>
  )
}

export default Accessorie